import angular from "angular";
import { MenuItem } from "./MenuItem";
import { vsName as menuServiceName, MenuService } from "./MenuService";

export const vsName: string = menuServiceName
export const vsProviderName: string = `${vsName}Provider`

export class MenuProvider implements angular.IServiceProvider {
  readonly menuItems: MenuItem[] = []

  addMenuItem(item: MenuItem, order?: number) {
    const insertAt = order ?? this.menuItems.length
    this.menuItems.splice(insertAt, 0, item)
  }

  findMenuItem(id: string): MenuItem | null {
    return this.menuItems.find(mi => this.findMenuItemRecursively(id, mi)) ?? null
  }

  private findMenuItemRecursively(id: string, menuItem: MenuItem): MenuItem | null {
    if (menuItem.getId() === id) {
      return menuItem
    }

    menuItem.getChildren().forEach(mi => {
      const menuItem = this.findMenuItemRecursively(id, mi)
      if (menuItem) {
        return menuItem
      }
    })

    return null
  }

  readonly $get = [(): MenuService => {
    return new MenuService(this.menuItems)
  }]
}


